// ── PlantaCleanEditor Constants ──
// Design system QCO + Canvas configuration

// Colors
export const ORANGE = '#F97316';
export const NAVY = '#1E3A5F';
export const WHITE = '#FFFFFF';
export const BG_GRAY = '#F3F4F6';
export const WALL_EXT_COLOR = '#4B5563';
export const WALL_INT_COLOR = '#9CA3AF';
export const WALL_SELECTED_COLOR = ORANGE;
export const ROOM_FILL_DEFAULT = 'transparent';
export const ROOM_FILL_OK = 'rgba(249,115,22,0.04)';
export const ROOM_STROKE_DEFAULT = 'transparent';
export const ROOM_STROKE_SELECTED = ORANGE;
export const DOOR_ARC_COLOR = '#6B7280';
export const WINDOW_COLOR = '#3B82F6';
export const DIM_COLOR = '#3B82F6';

// Canvas dimensions
export const VIRTUAL_SIZE = 1000;   // Virtual coordinate space (units)
export const WALL_THICKNESS = 6;    // External wall thickness (px)
export const WALL_INT_THICKNESS = 4; // Internal wall thickness (px)
export const PADDING = 80;          // Padding around the plant (px) — extra space for cotas
export const SNAP_GRID = 5;         // Snap grid (virtual units)
export const TOLERANCE = 8;         // Wall-room matching tolerance (virtual units)
export const HITBOX_EXPAND = 10;    // Extra hitbox for walls in edit mode (px)

// Room family colors (matching PlantaOverlay)
export const CORES_FAMILIA = {
  social: '#3B82F6',
  dormitorio: '#8B5CF6',
  dorm: '#8B5CF6',
  area_molhada_chuveiro: '#06B6D4',
  area_molhada_seca: '#06B6D4',
  wet: '#06B6D4',
  servico: '#F59E0B',
  serv: '#F59E0B',
  circulacao: '#6B7280',
  circ: '#6B7280',
  garagem: '#78716C',
  varanda: '#22C55E',
  sacada: '#10B981',
  deposito: '#A3A3A3',
  closet: '#8B5CF6',
};

// Acabamento options
export const ACABAMENTO_OPTIONS = {
  piso: [
    { v: '', l: 'Selecionar...' },
    { v: 'ceramica', l: 'Cerâmica' },
    { v: 'porcelanato', l: 'Porcelanato' },
    { v: 'porcelanato_ret', l: 'Porcelanato retificado' },
    { v: 'vinilico', l: 'Vinílico' },
    { v: 'laminado', l: 'Laminado' },
    { v: 'cimento_queimado', l: 'Cimento queimado' },
  ],
  parede: [
    { v: '', l: 'Selecionar...' },
    { v: 'pintura_acrilica', l: 'Pintura acrílica' },
    { v: 'pintura_latex', l: 'Pintura látex' },
    { v: 'textura', l: 'Textura' },
    { v: 'grafiato', l: 'Grafiato' },
  ],
  rev: [
    { v: '', l: 'Selecionar...' },
    { v: 'ceramica_30x60', l: 'Cerâmica 30×60' },
    { v: 'ceramica_60x60', l: 'Cerâmica 60×60' },
    { v: 'porcelanato_60x120', l: 'Porcelanato 60×120' },
    { v: 'pastilha', l: 'Pastilha' },
  ],
  rodape: [
    { v: '', l: 'Selecionar...' },
    { v: 'ceramica_10cm', l: 'Cerâmica 10cm' },
    { v: 'poliestireno', l: 'Poliestireno' },
    { v: 'madeira', l: 'Madeira' },
    { v: 'porcelanato', l: 'Porcelanato' },
    { v: 'sem', l: 'Sem rodapé' },
  ],
  teto: [
    { v: '', l: 'Selecionar...' },
    { v: 'pintura', l: 'Pintura' },
    { v: 'gesso_liso', l: 'Gesso liso' },
    { v: 'gesso_tabicado', l: 'Gesso tabicado' },
    { v: 'forro_pvc', l: 'Forro PVC' },
    { v: 'forro_madeira', l: 'Forro madeira' },
  ],
  mat_porta: [
    { v: 'madeira', l: 'Madeira semi-oca' },
    { v: 'madeira_macica', l: 'Madeira maciça' },
    { v: 'aluminio', l: 'Alumínio' },
    { v: 'pvc', l: 'PVC' },
  ],
  mat_janela: [
    { v: 'aluminio', l: 'Alumínio' },
    { v: 'aluminio_persiana', l: 'Alumínio c/ persiana' },
    { v: 'pvc', l: 'PVC' },
    { v: 'madeira', l: 'Madeira' },
  ],
};

// Family classification for wet rooms
export const WET_FAMILIES = [
  'wet', 'area_molhada_chuveiro', 'area_molhada_seca',
];

export function isWetRoom(familia) {
  if (!familia) return false;
  const f = familia.toLowerCase();
  return WET_FAMILIES.includes(f) || f.includes('wc') || f.includes('banheiro') || f.includes('lavabo');
}
